import { useState, useEffect } from "react";
import { postDoctors, getPageFloorElement, postDoctorDetail, queryYellowPagesDoctorDetail } from "api/doctor-list";
import { useLocation, useParams } from "react-router-dom";
import { getNethpHref } from '@jdhfe/seouifuncs/dist/tools/getNethpHref';
import { Helmet } from "react-helmet";
// import { useMount } from "hooks/use-lifecycle";
import logo from "../../asset/img/login/logo.png";
import Triple from "../../asset/img/login/Triple.png";
import selfSupport from "../../asset/img/login/self-support.png";
import Prescribible1 from "../../asset/img/login/Prescribible1.png";
import Group1 from "../../asset/img/login/Group1.png"; // 对勾
import Group2 from "../../asset/img/login/Group2.png"; // 资
import Group3 from "../../asset/img/login/Group3.png"; // 证
import Group4 from "../../asset/img/login/Group4.png"; // 人脸
import TripleHospital from "../../asset/img/login/Class-A-tertiary-hospital.png";

import icon_right from "../../asset/img/login/icon_right.png";
import evaluate1 from "../../asset/img/login/evaluate1.png";
import evaluate2 from "../../asset/img/login/evaluate2.png";
import evaluate3 from "../../asset/img/login/evaluate3.png";
import evaluate4 from "../../asset/img/login/evaluate4.png";

import QRCode from "qrcode.react";
import { Popover } from "antd";
import styles from "./index.less";
import { ErrorComp } from "components/error";
import { handleDoctorData } from 'utils/index';
import { targetLink } from 'utils/index';
import { getQrCodeUrl } from "utils/doctor";
import { doctorNav } from "utils/hospital";
import { getNavigationBarDtoList } from "api/tab-bar";
import HospitalNav from "pages/hospital/components/Nav";

const Dianping = () => {
  const params = useParams<Record<any, any>>();
  const [current, setCurrent] = useState<any>(1); // 页数
  const [disease, setDisease] = useState<any>(0); // 疾病id
  const [pageId, setPageId] = useState<any>(); // 疾病医生id
  const [departData, setDepartData] = useState<any>(); // 医生数据
  const [positiveDiagData, setPositiveDiagData] = useState<any>();
  const [nextPage, setNextPage] = useState<any>(true);
  const [loading, setLoading] = useState(true);

  const [navList, setNavList] = useState<any[]>();
  const getNavigationBarDtoFunc = (baseNav?: any[]) => {
    const baseNavList = baseNav;
    // 后端控制tab的展示和链接
    getNavigationBarDtoList({ currentUrl: window.location.href }).then(
      (res: any) => {
        const realList = res?.map((item: any) => {
          const url = item.url;
          let cItem;
          try {
            const Url = new URL(url);
            const path = Url.pathname;
            cItem = baseNavList?.find((iitem) => iitem.url === path);
          } catch (e) {
            console.log(e);
          }

          return {
            ...cItem,
            ...item,
          };
        });
        setNavList(realList?.length ? realList : undefined);
        // setNavList(realList?.length ? realList : baseNavList);
      }
    ).catch(e=>{
      console.log(e)
      // setNavList(baseNavList);
    })
  };
  useEffect(()=>{
    if(pageId){
      const baseNav = doctorNav(`${pageId}`);
      // @ts-ignore
      // setNavList(baseNav);
      getNavigationBarDtoFunc(baseNav);
    }
  },[pageId]);
  
  const routerPath = useLocation();
  const timeStampFun = (timeStamp: string | number | Date) => {
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = Number(date.getMonth()) + 1;
    const day = date.getDate();
    let hour: any = date.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    let minute: any = date.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    return year + "." + month + "." + day;
  };
  useEffect(() => {
    if (params.id.indexOf("-") != -1) {
      setCurrent(params.id.substring(params.id.indexOf("-") + 1));
    }
    if (params.id.indexOf("_") != -1) {
      setPageId(params.id.substring(0, params.id.indexOf("_")));
      if (params.id.indexOf("-") != -1) {
        getPageFloorElementFun(
          params.id.substring(0, params.id.indexOf("_")),
          params.id.substring(
            params.id.indexOf("_") + 1,
            params.id.indexOf("-")
          )
        );
        setDisease(
          params.id.substring(
            params.id.indexOf("_") + 1,
            params.id.indexOf("-")
          )
        );
      } else {
        getPageFloorElementFun(
          params.id.substring(0, params.id.indexOf("_")),
          params.id.substring(params.id.indexOf("_") + 1)
        );
        setDisease(params.id.substring(params.id.indexOf("_") + 1));
      }
      getinitFun(params.id.substring(0, params.id.indexOf("_")));
    } else {
      if (params.id.indexOf("-") != -1) {
        getPageFloorElementFun(
          params.id.substring(0, params.id.indexOf("-")),
          null
        );
        setPageId(params.id.substring(0, params.id.indexOf("-")));
        getinitFun(params.id.substring(0, params.id.indexOf("-")));
      } else {
        getPageFloorElementFun(params.id, null);
        setPageId(params.id);
        getinitFun(params.id);
      }
    }
  }, []);

  // 黄页医生详情 黄页 排班
  const pyqueryYellowPagesDoctorDetail = () => {
    queryYellowPagesDoctorDetail({
      yellowpagesDocId: params.id
    }).then((res: any) => {
      setDepartData({
        ...res,
        doctorSource: 1,
        docGoodAt: res.docGoodat || '',
        titleName: res.teacherTitle,
        docId: res.yellowpagesDocId,
        doctorHeadImg: res.docHeadPic
      });
    }).finally(() => setLoading(false));
  }

  const getinitFun = (id: any) => {
    if (id) {
      Promise.all([
        queryYellowPagesDoctorDetail({
          yellowpagesDocId: id || params.id.substring(0, params.id.indexOf("_"))
        }),
        postDoctorDetail({
          doctorId: id,
          onLineChannelName: "nethp",
          queryServiceAndTag: true,
          queryYellowDoctor: true,
        })
      ]).then((result:any) => {
        if(result?.[0]?.yellowpagesDocId){
          const res = result?.[0];
          setDepartData({
            ...res,
            doctorSource: 1,
            docGoodAt: res.docGoodat || '',
            titleName: res.teacherTitle,
            docId: res.yellowpagesDocId,
            doctorHeadImg: res.docHeadPic
          });
        }else if(result?.[1].doctorId){
          const resData:any = handleDoctorData(result?.[1]);
          setDepartData(resData);
        }
      }).catch(() => setLoading(false)).finally(() => setLoading(false));

      // pyqueryYellowPagesDoctorDetail()
      // postDoctorDetail({
      //   doctorId: id,
      //   onLineChannelName: "nethp",
      //   queryServiceAndTag: true,
      //   queryYellowDoctor: true,
      // }).then((res: any) => {
      //   if(res.doctorId){
      //     const resData:any = handleDoctorData(res);
      //     setDepartData(resData);
      //   }
      // }).finally(() => setLoading(false));
    }
  };
  const getPageFloorElementFun = (doctorId: any, diseases: any) => {
    getPageFloorElement({
      genericParam: {
        queryParam: [
          {
            doctorId,
            pageNo:
              params.id.indexOf("-") != -1
                ? Number(params.id.substring(params.id.indexOf("-") + 1))
                : 1,
            pageSize: 20,
            diseases: [],
            tenantId: "JD8888",
            sortType: 1,
          },
          null,
        ],
      },
      floorName: "comment",
    }).then((res: any) => {
      if (res.count && diseases > 0) {
        getPageFloorElement({
          genericParam: {
            queryParam: [
              {
                doctorId,
                pageNo:
                  params.id.indexOf("-") != -1
                    ? Number(params.id.substring(params.id.indexOf("-") + 1)) +
                      1
                    : 1,
                pageSize: 20,
                diseases: [res?.diseaseLabels[diseases].disease],
                tenantId: "JD8888",
                sortType: 1,
              },
              null,
            ],
          },
          floorName: "comment",
        }).then((resf: any) => {
          if (resf) {
            if (resf.hasNextPage === undefined) {
              if (resf.evaluationDTOList?.length) {
                setNextPage(true);
              } else {
                setNextPage(false);
              }
            } else {
              setNextPage(resf.hasNextPage);
            }
          } else {
            setNextPage(false);
          }
        });
        getPageFloorElement({
          genericParam: {
            queryParam: [
              {
                doctorId,
                pageNo:
                  params.id.indexOf("-") != -1
                    ? params.id.substring(params.id.indexOf("-") + 1)
                    : 1,
                pageSize: 20,
                diseases: [res?.diseaseLabels[diseases].disease],
                tenantId: "JD8888",
                sortType: 1,
              },
              null,
            ],
          },
          floorName: "comment",
        }).then((res: any) => {
          setPositiveDiagData(res);
        });
      } else {
        getPageFloorElement({
          genericParam: {
            queryParam: [
              {
                doctorId,
                pageNo:
                  params.id.indexOf("-") != -1
                    ? Number(params.id.substring(params.id.indexOf("-") + 1)) +
                      1
                    : 1,
                pageSize: 20,
                diseases: [],
                tenantId: "JD8888",
                sortType: 1,
              },
              null,
            ],
          },
          floorName: "comment",
        }).then((resf: any) => {
          if (resf) {
            if (resf.hasNextPage === undefined) {
              if (resf.evaluationDTOList?.length) {
                setNextPage(true);
              } else {
                setNextPage(false);
              }
            } else {
              setNextPage(resf.hasNextPage);
            }
          } else {
            setNextPage(false);
          }
        });
        setPositiveDiagData(res);
      }
    });
  };
  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      window.open("/");
    }
  };
  const qrCodeUrl = getQrCodeUrl(pageId);
  const content = (
    <div className={styles.overbookingCodebotton}>
      <QRCode value={qrCodeUrl} size={80} />
      <div>
        <h3>扫码关注医生</h3>
        <h6>关注{departData?.docName}医生，方便随时提问</h6>
      </div>
    </div>
  );
  const onClickhref = async (url: any) => {
    targetLink(url);
  };
  let doctorTagDTOMap =
    departData?.doctorTagDTOMap &&
    Object.keys(departData?.doctorTagDTOMap).length > 0 &&
    departData?.doctorTagDTOMap["1"]
      ? departData?.doctorTagDTOMap["1"].filter((val: any) => {
          return val.dictionaryType == 1 && val.dictionaryId == 10073;
        })
      : "";
  if (disease) {
    let positiveDiagDataLength = positiveDiagData?.diseaseLabels
      ? positiveDiagData?.diseaseLabels[disease].disease
      : "";
    document.title =
      departData?.hospitalName +
      departData?.departName +
      departData?.docName +
      "治疗" +
      positiveDiagDataLength +
      "怎么样_好不好【口碑_评价】-京东健康互联网医院";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        departData?.hospitalName +
          departData?.departName +
          departData?.docName +
          "治疗" +
          positiveDiagDataLength +
          "口碑好不好，怎么样？京东健康互联网医院1000万+患者真实口碑评价及就医分享帮助您了解" +
          departData?.hospitalName +
          departData?.departName +
          departData?.docName +
          "擅长、医术及治疗效果，患者就诊后分享的患者点评，是对治疗效果的主观反馈，帮助患者了解医生到底好不好，怎么样。"
      );
    document
      .querySelector('meta[name="keywords"]')
      ?.setAttribute(
        "content",
        departData?.docName +
          "," +
          departData?.docName +
          "治疗" +
          positiveDiagDataLength +
          "口碑," +
          departData?.docName +
          "治疗" +
          positiveDiagDataLength +
          "怎么样"
      );
  } else {
    document.title =
      departData?.hospitalName +
      departData?.departName +
      departData?.docName +
      "评价/口碑怎么样__好不好-京东健康互联网医院";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        departData?.hospitalName +
          departData?.departName +
          departData?.docName +
          "口碑好不好，怎么样？京东健康互联网医院1000万+患者真实口碑评价及就医分享帮助您了解" +
          departData?.hospitalName +
          departData?.departName +
          departData?.docName +
          "擅长、医术及治疗效果，患者就诊后分享的患者点评，是对治疗效果的主观反馈，帮助患者了解医生到底好不好，怎么样。"
      );
    document
      .querySelector('meta[name="keywords"]')
      ?.setAttribute(
        "content",
        departData?.docName +
          "," +
          departData?.docName +
          "口碑," +
          departData?.docName +
          "怎么样"
      );
  }
  return (
    <div className={styles.dianping}>
      { !loading && !departData && <ErrorComp /> }
      {/* // top 医生信息*/}
      { !loading && departData && 
        <div className={styles.qalistBack}>
          {/* 当前位置： */}
          <div className={styles.describe}>
            <div>
              <p>京东健康</p>
              <span>{">"}</span>
              {/* 京东健康>{医院名称}>{医生姓名}>{医生姓名}医生的患者评价 */}
              {departData?.hospitalName && departData?.docName ? (
                <>
                  <p>{departData?.hospitalName}</p>
                  <span>{">"}</span>
                  <a
                    data-a-href = {
                      "/doctor/" + pageId
                    }
                    onClick={() => {
                    onClickhref("/doctor/" + pageId);
                  }}
                  >{departData?.docName}</a>
                  <span>{">"}</span>
                  <p data-tag-h1>{departData?.docName + "医生的患者评价"}</p>
                </>
              ) : null}
            </div>
          </div>
          {/* 医生信息 */}
          {departData && (
            <div className={styles.qalistBackBox}>
              <div className={styles.qalistBackList}>
                <div className={styles.doctorImg}>
                  <img
                    src={
                      "https://image.healthjd.com/nethpim/" +
                      departData?.doctorHeadImg
                    }
                    alt={departData?.docName}
                  />
                </div>
                <div className={styles.doctorBox}>
                  <div className={styles.doctorBoxTop}>
                    <a
                    data-a-href = {
                      "/doctor/" + pageId
                    }
                    onClick={() => {
                      onClickhref("/doctor/" + pageId);
                    }}
                    >{departData?.docName}
                    </a>
                    <span>{departData?.titleName}</span>
                    {departData?.selfSupport && (
                      <img
                        className={styles.selfSupport}
                        src={selfSupport}
                        alt=""
                      />
                    )}
                    {departData?.operationalOpenRxStatus === 1 && (
                      <img
                        className={styles.operationalOpenRxStatus}
                        src={Prescribible1}
                        alt=""
                      />
                    )}
                    {departData?.hospitalGrade === 3 && (
                      <img className={styles.hospitalGrade} src={Triple} alt="" />
                    )}
                  </div>
                  <div className={styles.doctorBoxTop1}>
                    <span 
                      onClick={(e) => {
                        e.stopPropagation();
                        onClickOpen("/hospital/" + departData?.hospitalId);
                      }}
                      data-a-href={"/hospital/" + departData?.hospitalId}>{departData?.hospitalName}</span>
                    {' '}
                    <span onClick={(e) => {
                      e.stopPropagation();
                      onClickOpen(`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`)
                    }}
                    data-a-href={`/hospital/department/${departData?.hospitalId}-${departData?.secondDepartId}`}
                    >{departData?.secondDepartName}</span>
                  </div>
                  <div className={styles.doctorBoxTop2}>
                    执业证：{departData?.practiceCode || "暂无资料"}
                  </div>
                </div>
              </div>
              {departData?.doctorSource == 0 &&
                (departData?.qualificationsCode ||
                  departData?.practiceCode ||
                  doctorTagDTOMap?.length > 0) && (
                  <div className={styles.qalistBackRight}>
                    <div className={styles.qalistBackRightText}>实名认证</div>
                    {departData?.qualificationsCode && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group2} alt="" />
                          <div>
                            <span>医师资格证</span>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                    {departData?.practiceCode && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group3} alt="" />
                          <div>
                            <span>医师执业照</span>
                            <p>执业证书编号:{departData?.practiceCode}</p>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                    {doctorTagDTOMap?.length > 0 && (
                      <div className={styles.qalistBackRightList}>
                        <div className={styles.qalistBackRightBox}>
                          <img src={Group4} alt="" />
                          <div>
                            <span>人脸识别认证</span>
                            <p>所有服务均由医生本人提供</p>
                          </div>
                        </div>
                        <div className={styles.qalistBackRightBox1}>
                          <img src={Group1} alt="" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          )}
        </div>
      }
      {/* 导航 */}
      { !loading && departData &&
        <div className={styles.nav}>
          <HospitalNav pageId={pageId} navList={navList} />
        </div>
      }
      {/* 内容 */}
      { !loading && departData &&
        <div className={styles.content}>
          {/* 左 */}
          <div className={styles.left}>
            {/* 患者评价 */}
            { positiveDiagData?.evaluationDTOList?.length ? 
            <div className={styles.evaluate}>
              <div className={styles.evaluateTit}>
                <div className={styles.evaluateTitText}>
                  {departData?.docName}的患者评价
                </div>
              </div>
              <div className={styles.evaluateTop}>
                <div className={styles.evaluateTopLeft}>
                  <img src={evaluate1} alt="" />
                  <div className={styles.evaluateTopLeftText}>
                    {positiveDiagData && (
                      <p>
                        {positiveDiagData?.positive * 100 || '' }
                        {positiveDiagData?.positive ? <span>%</span> : <span>暂无评价</span>}
                      </p>
                    )}

                    <h4>医生好评率</h4>
                  </div>
                </div>
                <img className={styles.evaluate2img} src={evaluate2} alt="" />
                <div className={styles.evaluateTopRight}>
                  <div className={styles.evaluateTopRight1}>
                    <h3>回复质量</h3>
                    <div>
                      <p
                        style={{
                          width:
                            positiveDiagData &&
                            positiveDiagData?.replyQualityPositive * 100 + "%",
                        }}
                      ></p>
                    </div>
                    {positiveDiagData &&
                    positiveDiagData?.replyQualityPositive ? (
                      <span>
                        {positiveDiagData?.replyQualityPositive * 100 + "%好评"}
                      </span>
                    ) : (
                      <span>暂无评价</span>
                    )}
                  </div>
                  <div className={styles.evaluateTopRight1}>
                    <h3>服务态度</h3>
                    <div>
                      <p
                        style={{
                          width:
                            positiveDiagData &&
                            positiveDiagData?.serviceAttitudePositive * 100 + "%",
                        }}
                      ></p>
                    </div>
                    {positiveDiagData &&
                    positiveDiagData?.serviceAttitudePositive ? (
                      <span>
                        {positiveDiagData?.serviceAttitudePositive * 100 +
                          "%好评"}
                      </span>
                    ) : (
                      <span>暂无评价</span>
                    )}
                  </div>
                  <div
                    className={`${styles.evaluateTopRight1} ${styles.evaluateTopRight2}`}
                  >
                    <h3>回复速度</h3>
                    <div>
                      <p
                        style={{
                          width:
                            positiveDiagData &&
                            positiveDiagData?.replySpeedPositive * 100 + "%",
                        }}
                      ></p>
                    </div>
                    {positiveDiagData && positiveDiagData?.replySpeedPositive ? (
                      <span>
                        {positiveDiagData?.replySpeedPositive * 100 + "%好评"}
                      </span>
                    ) : (
                      <span>暂无评价</span>
                    )}
                  </div>
                </div>
              </div>
              {/* teb切换 写死的第一个高亮 */}
              <div className={styles.evaluateTeb}>
                {positiveDiagData &&
                  positiveDiagData?.diseaseLabels &&
                  positiveDiagData?.diseaseLabels.map((val: any, index: any) => {
                    return (
                      <a
                        className={`${styles.evaluateTebBtn} ${
                          index == disease ? styles.evaluateTebBtnactive : ""
                        }`}
                        data-a-href={
                          index == 0
                            ? "/dianping/" + pageId
                            : "/dianping/" + pageId + "_" + index
                        }
                        key={index}
                        onClick={() => {
                          index == 0
                            ? (window.location.href = "/dianping/" + pageId)
                            : (window.location.href =
                                "/dianping/" + pageId + "_" + index);
                        }}
                      >
                        {val.disease}
                      </a>
                    );
                  })}
              </div>
              {/* 患者评价列表 */}
              <div className={styles.evaluateList}>
                <ul>
                  {positiveDiagData &&
                  positiveDiagData?.evaluationDTOList &&
                  positiveDiagData?.evaluationDTOList.length > 0 ? (
                    positiveDiagData?.evaluationDTOList.map(
                      (val: any, idnex: any) => {
                        return (
                          <li key={idnex}>
                            <div className={styles.evaluateListTop}>
                              <div className={styles.evaluateListTopLeft}>
                                <div className={styles.evaluateListTopName}>
                                  {val.userNickName}
                                </div>
                                <span />
                                <div className={styles.evaluateListTopLeftImg}>
                                  {[1, 2, 3, 4, 5].map(
                                    (itme: any, index: any) => {
                                      if (itme <= val.compositeScore) {
                                        return (
                                          <img
                                            key={index}
                                            src={evaluate3}
                                            alt=""
                                          />
                                        );
                                      } else {
                                        return (
                                          <img
                                            key={index}
                                            src={evaluate4}
                                            alt=""
                                          />
                                        );
                                      }
                                    }
                                  )}
                                </div>
                                <div className={styles.evaluateListTopEvaluea}>
                                  回复质量：{val.replyQualityScoreDesc}
                                  <span />
                                  服务态度：{val.serviceAttitudeScoreDesc}
                                  <span />
                                  回复速度：{val.replySpeedScoreDesc}
                                </div>
                              </div>
                              <div className={styles.evaluateListTopRight}>
                                {timeStampFun(val.created)}
                              </div>
                            </div>
                            <div className={styles.evaluateListText}>
                              {val.content || val?.diseaseDescription || "此用户未填写评价内容"}
                            </div>
                            <div className={styles.evaluateListButtom}>
                              {/* {val?.diseaseDescription && (
                                <p>确诊疾病：{val?.diseaseDescription}</p>
                              )} */}
                              {val?.serviceTypeName && (
                                <span>{val.serviceTypeName}</span>
                              )}
                            </div>
                          </li>
                        );
                      }
                    )
                  ) : (
                    <li className={styles.serviceTypeName}>暂无患者评价</li>
                  )}
                </ul>
              </div>
              <div className={styles.pagination}>
                {/* // 分页 */}
                {current != 1 && (
                  <a
                    className={styles.prev}
                    onClick={() => {
                      let currents: any =
                        current > 1 ? Number(current) - 1 : current;
                      let diseaseID = disease
                        ? "_" + disease + "-" + currents
                        : "-" + currents;
                      let url =
                        window.location.origin +
                        "/dianping/" +
                        pageId +
                        diseaseID;
                      window.location.href = url;
                    }}
                  >
                    上一页
                  </a>
                )}
                {nextPage && (
                  <a
                    data-a-href={
                      "/dianping/" +
                        pageId +
                        (disease
                          ? "_" + disease + "-" + (Number(current))
                          : "-" + (Number(current)))
                    }
                    className={styles.next}
                    onClick={() => {
                      let currents: any = Number(current) + 1;
                      let diseaseID = disease
                        ? "_" + disease + "-" + currents
                        : "-" + currents;
                      let url =
                        window.location.origin +
                        "/dianping/" +
                        pageId +
                        diseaseID;
                      window.location.href = url;
                    }}
                  >
                    下一页
                  </a>
                )}
              </div>
            </div>
            : null
            }
          </div>
          {/* 右 */}
          <div className={styles.right}>
            <div className={styles.rightFloat}>
              {departData && (
                <div className={styles.rightdoctor}>
                  <h2>医生成就</h2>
                  <div className={styles.rightdoctorCont}>
                    <div className={styles.rightdoctorCont1}>
                      <span>
                        {departData?.patientEvaluationRate?.split('%')?.[0] || "暂无"}
                        <i>{departData?.patientEvaluationRate ? '%' : ""}</i>
                      </span>
                      <p>好评率</p>
                    </div>
                    <div className={styles.rightdoctorCont2} />
                    <div className={styles.rightdoctorCont1}>
                      <span>{departData?.receivePatientNum || "暂无"}</span>
                      <p>接诊人数</p>
                    </div>
                    <div className={styles.rightdoctorCont2} />
                    <div className={styles.rightdoctorCont1}>
                      <span>
                        {departData?.averageResponseTimeDTO?.averageResponseTime || "暂无"}
                        <i>
                          {departData?.averageResponseTimeDTO?.timeUnit || ""}
                        </i>
                      </span>
                      <p>平均响应</p>
                    </div>
                  </div>
                </div>
              )}
              {departData?.docName && (
                <div className={styles.overbookingCode}>
                  <QRCode
                    value={qrCodeUrl}
                    size={80}
                  />
                  <div>
                    <h3>扫码关注医生</h3>
                    <h6>关注{departData?.docName}医生，方便随时提问</h6>
                  </div>
                </div>
              )}
              </div>
          </div>
        </div>
      }
      {/* // 底部线 */}
      <div className={styles.footerLine}>
        <p></p>
      </div>
      <div className={styles.footerData} id="m_common_bottom" />
      {/* 底部 */}
      <div className={styles.bottom}>
        <div className={styles.bottomDoctorInfo}>
          {departData && (
            <>
              <img
                src={
                  "https://image.healthjd.com/nethpim/" +
                  departData?.doctorHeadImg
                }
                alt={departData?.docName}
              />
              <div className={styles.doctorInfoImgRight}>
                <div className={styles.doctorInfoImgTop}>
                  <div className={styles.doctorInfoImgTopName}>
                    {departData?.docName}
                  </div>
                  <span>{departData?.titleName}</span>
                  {/* <span>{departData?.departName}</span> */}
                  <p>已认证</p>
                </div>
                <div className={styles.doctorInfoImgBotton}>
                  {departData?.hospitalGrade === 3 && (
                    <img src={TripleHospital} alt="" />
                  )}
                  <p>
                    {departData?.hospitalName} {departData?.secondDepartName}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.bottomBtn}>
          <Popover content={content}>
            <button className={styles.bottomBtn1}>立即咨询</button>
          </Popover>
          <Popover content={content}>
            <button className={styles.bottomBtn2}>
              扫码关注医生，方便随时咨询
            </button>
          </Popover>
        </div>
      </div>
    </div>
  );
};

export default Dianping;
